import styled from "styled-components";
import { FC } from "react";

import Text from "@/components/Text";
import PulsingLoader from "@/components/PulsingLoader";

const LoaderHolder = styled.div`
  text-align: center;
  margin: 120px 0 124px;
`;

const LoaderTextHolder = styled.div`
  max-width: 260px;
  margin: 0 auto;
`;

const StyledText = styled(Text)`
  margin-top: 20px;
  margin-bottom: 6px;
`;

interface Props {
  className?: string;
}

const AiSuggestionsLoader: FC<Props> = ({ className }) => {
  return (
    <LoaderHolder className={className}>
      <PulsingLoader />
      <LoaderTextHolder>
        <StyledText $type="button">Loading data ...</StyledText>
        <Text $color="gray" $type="captionSemibold">
          Please be patient, this action may take a little longer in some cases
        </Text>
      </LoaderTextHolder>
    </LoaderHolder>
  );
};

export default AiSuggestionsLoader;
